import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

/**
 * Use this component to set standardized padding and max width on pages.
 */
@Component({
  imports: [CommonModule],
  selector: 'tabs-inner-wrap',
  standalone: true,
  styleUrls: ['./tabs-inner-wrap.component.scss'],
  template: '<ng-content/>',
})
export class TabsInnerWrapComponent {}
